// extracted by mini-css-extract-plugin
export default {"googleLoginButton":"styles_googleLoginButton__V1-Hs"};